import React, { useEffect,useState } from 'react';
import { Card, Avatar, Statistic, Row, Col, List, Empty, Space, Input,Dropdown ,Button, message } from 'antd';
import { LikeOutlined, FileTextOutlined, TrophyOutlined, SearchOutlined } from '@ant-design/icons';
import moment from 'moment';
import { size } from 'lodash';
import PostDetail from './PostDetail';
import { API_BASE_URL } from '../config';
import { useStaffSearch } from '../stores/StaffSearch';
import LabelComponent from '../components/LableComponent';
const { Search } = Input;

const Profile = ({ actionId,selectedPostId,u2, user,posts, onRefresh,accessToken,onLike,onBack,scrollToComments,onPostClick}) => {

    const { menuPropszhuye, searchQuery, searchingUsers, selectedUsers, dropdownOpen,selectedUsersZhuye, setSelectedUsersZhuye,setSearchQuery, setSelectedUsers, handleInputClick, handleDropdownVisibleChange, handleSelectUserWithClose, handleSearchUsers, handleRemoveUser, resetSearchState } = useStaffSearch({ accessToken, apiBaseUrl: API_BASE_URL });
    const [userZhuye, setUserZhuye] = useState();
    const [postZhuye, setPostZhuye] = useState();
    const [homeData, setHomeData] = useState();

  useEffect(() => {
    if (selectedUsersZhuye) {
      homedetail(selectedUsersZhuye.userId);
      setUserZhuye(selectedUsersZhuye);
      console.log("selectedUsersZhuye.userId",selectedUsersZhuye.userId);
      console.log("post:",posts);
      setPostZhuye(posts.filter(post => post.userid === selectedUsersZhuye.userId));
    }
  }, [selectedUsersZhuye,posts,user]);
  useEffect(() => {
    if (u2) {
      setSelectedUsersZhuye({
        userId: u2.userid,
        name: u2.name,
        avatar: u2.avatar,
      });
    }
  }, [u2,posts]);
  useEffect(() => {
    if (u2&&user&&actionId === "likehome") {
      update_homelike();
    }
  }, [u2,user]);
  const homedetail = async (userid) => {
    try {
      const response = await fetch(`${API_BASE_URL}/database/search_homedetail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userid: userid,
        })
      });
      const data = await response.json();
      if(data){
        setHomeData(data);
      }
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };
  const update_homelike = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/database/update_homelike`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          u1: user.userId,
          u2:selectedUsersZhuye.userId
        })
      });
      const data = await response.json();
      if(data){
        message.info("点赞成功")
      }else{
        message.error("今日你已经为他点过赞了")
      }
      homedetail(selectedUsersZhuye.userId);
    } catch (error) {
      console.error('插入数据失败:', error);
    }
  };

  if (!selectedUsersZhuye) {
    return (
      <>
      <Space>
            我想看他的主页:
            <Dropdown 
            menu={menuPropszhuye} 
            open={dropdownOpen}
            onOpenChange={handleDropdownVisibleChange}
            >
            <Input
                placeholder="输入Ta姓名"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onPressEnter={(e) => {
                e.preventDefault();
                handleSearchUsers();
                }}
                onClick={handleInputClick}
                style={{ width: 160 }}
                prefix={<SearchOutlined />}
            />
            </Dropdown>
            <Button 
            type="primary" 
            icon={<SearchOutlined />}
            loading={searchingUsers}
            onClick={handleSearchUsers}
            >
            搜索
            </Button>
        </Space>
      <div style={{ textAlign: 'center', padding: '50px 0' }}>
        <Empty description="暂无内容，请选择想要查看的用户..." />
      </div>
      </>
    );
  }
  if (!userZhuye) {
    return (
      <div style={{ textAlign: 'center', padding: '50px 0' }}>
        <Empty description="加载用户信息中..." />
      </div>
    );
  }
  
  const selectedPost = postZhuye.find(post => post.vp_id === selectedPostId);
  return (
    <>
    {selectedPostId ? (
        <PostDetail
          post={selectedPost}
          currentUser={user}
          onLike={onLike}
          onBack={onBack}
          onRefresh={onRefresh}
          scrollToComments={scrollToComments}
        />
        ) : (
    <div>
        <Space>
            我想看他的主页:
            <Dropdown 
            menu={menuPropszhuye} 
            open={dropdownOpen}
            onOpenChange={handleDropdownVisibleChange}
            >
            <Input
                placeholder="输入Ta姓名"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onPressEnter={(e) => {
                e.preventDefault();
                handleSearchUsers();
                }}
                onClick={handleInputClick}
                style={{ width: 160 }}
                prefix={<SearchOutlined />}
            />
            </Dropdown>
            <Button 
            type="primary" 
            icon={<SearchOutlined />}
            loading={searchingUsers}
            onClick={handleSearchUsers}
            >
            搜索
            </Button>
        </Space>
      <Card bordered={true} style={{ marginBottom: 16 }}>
        <div style={{ textAlign: 'center', padding: 20 }}>
          <Avatar 
            src={userZhuye.avatar}
            alt={userZhuye.name}
            size={100}
            style={{ marginBottom: 16 }}
          />
          <h2 style={{ margin: 0, marginBottom: 8 }}>{userZhuye.name}</h2>
          
          <Button 
            type="primary" 
            icon={<LikeOutlined />}
            onClick={update_homelike}
            style={{ marginBottom: 16 }}
          >
            点赞主页
          </Button>
          
          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <Col span={8}>
              <Statistic 
                title="获得点赞" 
                value={homeData?.likes} 
                icon={<LikeOutlined />} 
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="被value的次数" 
                value={homeData?.values} 
                icon={<TrophyOutlined />} 
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="发布内容" 
                value={size(postZhuye)} 
                icon={<FileTextOutlined />} 
              />
            </Col>
          </Row>
        </div>
      </Card>
      <LabelComponent 
        user={user} 
        targetUserId={selectedUsersZhuye.userId}
      />
      
      <Card title="我的发布" bordered={true}>
        {postZhuye.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '50px 0' }}>
            <Empty description="你还没有发布任何内容" />
          </div>
        ) : (
          <List
            pagination={{
              onChange: page => {
                console.log(page);
              },
              pageSize: 3,
            }}
            itemLayout="vertical"
            dataSource={postZhuye}
            renderItem={item => (
              <List.Item>
                <List.Item.Meta
                  title={item.vp_title}
                  description={item.vp_datetime}
                  onClick={() => onPostClick(item.vp_id)}
                />
                <div onClick={() => onPostClick(item.vp_id)} style={{ marginTop: '10px',  display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 3, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <div dangerouslySetInnerHTML={{ __html: item.vp_content.replace(/<img[^>]*>/g, '') }} />
                </div>
              </List.Item>
            )}
          />
        )}
      </Card>
    </div>
        )}
    </>
  );
};

export default Profile;
